<div ref="eLabel" class="ag-header-cell-label" role="presentation">
  <span><button mat-raised-button (click)="clearAllSelCars()"
      class="cce-header-blue-button">Clear all</button></span>
  <span class="cce-header-white-title">SELECTED VEHICLES</span>
</div>